import { render, staticRenderFns } from "./MergeForm.vue?vue&type=template&id=6223e420&scoped=true"
import script from "./MergeForm.vue?vue&type=script&lang=js"
export * from "./MergeForm.vue?vue&type=script&lang=js"
import style0 from "./MergeForm.vue?vue&type=style&index=0&id=6223e420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6223e420",
  null
  
)

export default component.exports